import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { ChannelsComponent } from './features/channels/channels.component';
import { LoginComponent } from './features/login/login.component';
import { GameShowStatsComponent } from './features/game-show-stats/game-show-stats.component';
import { ShowArchiveComponent } from './features/show-archive/show-archive.component';
import { ShowDetailComponent } from './features/show-detail/show-detail.component';
import { CreatorSpaceComponent } from './features/creator-space/creator-space.component';
import { QuestionCatalogComponent } from './features/question-catalog/question-catalog.component';
import { QuestionTableDetailComponent } from './features/question-table-detail/question-table-detail.component';
import { ShowLobbyComponent } from './features/show-lobby/show-lobby.component';
import { ShowLobbyRoomComponent } from './features/show-lobby-room/show-lobby-room.component';

export const routes: Routes = [
  { path: '', component: HomeComponent, title: 'DaniiPlace | Home' },
  { path: 'kanaele', component: ChannelsComponent, title: 'DaniiPlace | Kanäle' },
  { path: 'spielshows', component: ShowArchiveComponent, title: 'DaniiPlace | Shows' },
  { path: 'creator-space', component: CreatorSpaceComponent, title: 'DaniiPlace | Creator Space' },
  { path: 'show-lobby', component: ShowLobbyComponent, title: 'DaniiPlace | Show Lobby' },
  { path: 'show-lobby/:id', component: ShowLobbyRoomComponent, title: 'DaniiPlace | Lobby' },
  { path: 'fragenkatalog', component: QuestionCatalogComponent, title: 'DaniiPlace | Fragenkatalog' },
  { path: 'fragenkatalog/:id', component: QuestionTableDetailComponent, title: 'DaniiPlace | Fragenkatalog Details' },
  { path: 'spielshows/archiv', redirectTo: '/spielshows' },
  { path: 'spielshows/statistik', component: GameShowStatsComponent, title: 'DaniiPlace | Spielshow-Übersicht' },
  { path: 'spielshows/:id', component: ShowDetailComponent, title: 'DaniiPlace | Show-Details' },
  { path: 'login', component: LoginComponent, title: 'DaniiPlace | Login' },
  { path: 'quizpoker', redirectTo: 'spielshows' },
  { path: '**', redirectTo: '' }
];
